import { keymap } from "prosemirror-keymap";
import { splitListItem } from "prosemirror-schema-list";
import { Extension } from "../../core/extension";
import { toggleListNode } from "../../commands/commands";
import { checkListNodes } from "./nodes";
import { CheckListItemView } from "./nodeviews";
import { checklistCommandSpec } from "./commands";
export class CheckListExtension extends Extension {
    addNodes(nodes) {
        return nodes.append(checkListNodes);
    }
    addPlugins(schema, plugins) {
        return plugins.concat([
            keymap({
                Enter: splitListItem(schema.nodes.check_list_item),
            }),
        ]);
    }
    addSlashCommands(commands) {
        return [...commands, checklistCommandSpec];
    }
    addNodeViews(schema, nodeViews) {
        return {
            ...nodeViews,
            check_list_item: (node, view, getPos) => new CheckListItemView(node, view, getPos),
        };
    }
    addCommands(schema) {
        return {
            toggleChecklist: toggleListNode(schema.nodes.check_list, schema.nodes.check_list_item),
        };
    }
}
